import { Text } from '@chakra-ui/react';
import { useField } from 'formik';

const ConditionalTextFormikField = ({ name, trueText, falseText = '', ...props }) => {
    const [field] = useField(name);

    const text = field.value ? trueText : falseText;

    if (!text) return null;

    return (
        <Text fontSize="sm" {...props}>
            {text}
        </Text>
    );
};

export default ConditionalTextFormikField;
